 
import 'allotment/dist/style.css'
import './shared/styles/global.css'
import 'driver.js/dist/driver.css'

import ReactDOM from 'react-dom/client'

import { LicenseInfo } from '@mui/x-license'

import { App } from './app/App'

const MUI_PREMIUM_LICENSE_KEY = import.meta.env.VITE_APP_MUI_PREMIUM_KEY || ''

LicenseInfo.setLicenseKey(MUI_PREMIUM_LICENSE_KEY)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <App />,
)
